// extracted by mini-css-extract-plugin
export default {"header":"CreateNewAccountHeader_header__wDRoM"};